module.exports = __webpack_public_path__ + "static/media/Group 9947.24cc953d.svg";